module.exports = __webpack_public_path__ + "img/5.ffbc0ffe.png";